import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function Login() {
  const { login, error } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const ok = await login(email, password);
    setBusy(false);
    if (ok) nav("/dashboard");
  };

  return (
    <div className="grid h-screen w-full grid-cols-1 lg:grid-cols-2">
      <div className="hidden lg:block relative overflow-hidden border-r border-border">
        <img
          src="https://images.pexels.com/photos/37118172/pexels-photo-37118172.jpeg"
          alt=""
          className="absolute inset-0 h-full w-full object-cover grayscale"
        />
        <div className="relative z-10 flex h-full flex-col justify-between p-12 text-white bg-black/50">
          <div>
            <div className="overline text-white/80">NAKİT.</div>
            <div className="mt-2 font-black text-4xl tracking-tight">
              Nakit Akışını Anlık Görün.
            </div>
          </div>
          <div className="max-w-md text-sm text-white/80 leading-relaxed">
            Gelir, gider, cari, banka ve çalışan ödemelerinizi tek yerden yönetin.
            Çoklu para birimi ve TCMB efektif satış kuru desteği ile TL karşılığı
            her yerde.
          </div>
        </div>
      </div>
      <div className="flex items-center justify-center bg-background px-6 py-12">
        <form
          onSubmit={submit}
          className="w-full max-w-sm space-y-6"
          data-testid="login-form"
        >
          <div>
            <div className="overline">Giriş</div>
            <h1 className="mt-2 text-3xl font-black tracking-tight">
              Hesabınıza giriş yapın
            </h1>
          </div>
          <div className="space-y-4">
            <div>
              <Label htmlFor="email">E-posta</Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="login-email"
                required
                className="mt-1"
                placeholder="email@ornek.com"
              />
            </div>
            <div>
              <Label htmlFor="password">Şifre</Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="login-password"
                required
                className="mt-1"
              />
            </div>
          </div>
          {error && (
            <div
              data-testid="login-error"
              className="rounded-md border border-destructive/40 bg-destructive/5 px-3 py-2 text-sm text-destructive"
            >
              {error}
            </div>
          )}
          <Button
            type="submit"
            disabled={busy}
            data-testid="login-submit"
            className="w-full"
          >
            {busy ? "Giriş yapılıyor..." : "Giriş Yap"}
          </Button>
          <div className="text-center text-xs text-muted-foreground">
            Yalnızca yetkili kullanıcılar giriş yapabilir.
          </div>
        </form>
      </div>
    </div>
  );
}
